import { Accordion } from 'react-bootstrap';
import xss from 'xss';
import styles from './AccordionItem.module.scss';

const AccordionItem = ({
  eventKey,
  header,
  body,
  children,
  renderBodyAsHtml = false,
}) => {
  if (!body && !children) return null;
  const headerClassname = `font-roboto ${styles.header}`;
  const bodyClassname = `font-roboto ${styles.body}`;
  const itemClassName = `${styles.item}`;

  const bodyTextSanitized = renderBodyAsHtml ? (
    // eslint-disable-next-line react/no-danger
    <div dangerouslySetInnerHTML={{ __html: xss(body) }} />
  ) : (
    <p>{body}</p>
  );

  return (
    <Accordion.Item className={itemClassName} eventKey={eventKey}>
      <Accordion.Header className={headerClassname}>{header}</Accordion.Header>
      <Accordion.Body className={bodyClassname}>
        {children}
        {bodyTextSanitized}
      </Accordion.Body>
    </Accordion.Item>
  );
};

export default AccordionItem;
